import * as React from "react";
import {ConditionProcessorBase} from "../../Core/Conditions/ConditionProcessorBase";
import {HideFieldContainer} from "./SubComponents/HideFieldContainer";

import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";
import {EventManager} from "shared/core/Events/EventManager";
import {GetFieldDescription} from "FormBuilder/Events/GetFieldDescription";
import {GetToolTip} from "FormBuilder/Events/GetToolTip";


export abstract class FBFieldBase<p extends FBFieldBaseProps=FBFieldBaseProps,s extends FBFieldBaseState=FBFieldBaseState> extends React.Component<p, s> {
    static defaultProps: Partial<FBFieldBaseProps> = {};
    public Instance:HTMLDivElement;


    public Conditions:ConditionProcessorBase[];



    constructor(props: p) {
        super(props);
        this.Model.ImmediateAnimation=true;
        this.InstanceRendered=this.InstanceRendered.bind(this);
        this.state = {} as s;




    }

    public get Model(){
        return this.props.Model;
    }
    public get FormBuilder():ContainerDataRetriever{
        return this.props.Model.FormBuilder;
    }

    public InstanceRendered(node:HTMLDivElement){
        this.Model.Instance=node;
    }








    componentDidMount(): void {
        this.Model.OnRefresh.Subscribe(this,()=>this.forceUpdate());
    }

    componentWillUnmount(): void {
        this.Model.OnRefresh.Unsubscribe(this);
    }





    public get Column(){
        return this.props.Model.Parent;
    }

    public Refresh()
    {
        this.forceUpdate();
    }


    public GetLabel(valueOverwrite:string=''){
        let value=this.props.Model.Options.Label;
        if(valueOverwrite!='')
            value=valueOverwrite;

        if(value!='')
            return (
                <div className={'rednaoLabel'} style={{fontWeight:'bold'}}>
                    <label >{value}</label>
                    {this.Model.Options.Required&&<span className={'rnRequiredInd'}>*</span>}
                    {this.Model.Options.Tooltip!=''&&EventManager.Publish(new GetToolTip(this.Model))}
                </div>
            );

        return null;
    }



    public render() {

        return (
            <HideFieldContainer Immediate={this.Model.ImmediateAnimation} IsVisible={this.Model.IsVisible||this.props.Model.Parent.IsDesign} >
                <div ref={this.InstanceRendered} style={{marginBottom:5}}  className={'rnField_'+this.Model.Options.Id+ ' rn'+this.Model.Options.Type+' rednaoWooField '+(!this.Model.GetIsValid()?'rnInvalid':'')} >
                    <div className={'rednaoControl'}>
                        {this.SubRender()}
                    </div>
                    {this.Model.Options.Description!=''&&EventManager.Publish(new GetFieldDescription(this.Model))}
                </div>
            </HideFieldContainer>
        )
    }



    public abstract SubRender();




}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface FBFieldBaseProps {
    Model:FBFieldBaseModel;

}

export interface FBFieldBaseState {

}

//#endregion "My Region"